import { createSelector } from 'reselect';

import getUser from '../getUser';

export default createSelector(
  getUser,

  (worker) => worker && !worker.custom_заблокирована_баланседа,
);